module.exports = __webpack_public_path__ + "static/media/timeline-step-2.b30f6529.png";